import { render, staticRenderFns } from "./textStyle.vue?vue&type=template&id=ed875454&scoped=true&"
import script from "./textStyle.vue?vue&type=script&lang=js&"
export * from "./textStyle.vue?vue&type=script&lang=js&"
import style0 from "./textStyle.vue?vue&type=style&index=0&id=ed875454&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed875454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed875454')) {
      api.createRecord('ed875454', component.options)
    } else {
      api.reload('ed875454', component.options)
    }
    module.hot.accept("./textStyle.vue?vue&type=template&id=ed875454&scoped=true&", function () {
      api.rerender('ed875454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/textStyle.vue"
export default component.exports